module.exports = __webpack_public_path__ + "static/media/pending-nuggets.49aa5d99.svg";